import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "./store"

export const selectChatMessages = (jid: string | undefined) => {
  return createSelector(
    (state: RootState) => state.messages,
    (messages) => (jid ? messages[jid] : undefined),
  )
}

export const selectMessagesFromChat = (jid: string | undefined) => {
  return createSelector(
    (state: RootState) => state.messages,
    (messages) => (jid ? messages[jid]?.messages : undefined),
  )
}

export const selectRetractionsFromChat = (jid: string | undefined) => {
  return createSelector(
    (state: RootState) => state.messages,
    (messages) => (jid ? messages[jid]?.messageRetractions : undefined),
  )
}

export const selectCorrectionsFromChat = (jid: string | undefined) => {
  return createSelector(
    (state: RootState) => state.messages,
    (messages) => (jid ? messages[jid]?.messageCorrections : undefined),
  )
}

export const selectMessages = createSelector(
  (state: RootState) => state.messages,
  (messages) => messages,
)

export const selectDeliveryOrdersFromChat = (jid: string | undefined) => {
  return createSelector(
    (state: RootState) => state.messages,
    (messages) =>
      jid ? messages[jid]?.messageIdsWithDeliveryOrder : undefined,
  )
}
